import { motion } from "framer-motion";
import "../../styles/cart.css";


const CustomerProductAddThanksPopup = ({ onClose, postType }) => {
  return (
    <motion.div
      className="thank-you-popup"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
    >
      <h2>Thank you for adding the {postType}!</h2>
      <p>
        It’s been added successfully. We’ll review it and make it live on our app within a few hours.
      </p>
      <button
        className="close-thank-you-popup-btn"
        onClick={onClose}
      >
        Close
      </button>
    </motion.div>
  );
};

export default CustomerProductAddThanksPopup;
